/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_StartedInputs */

const cs_pm_started = /** @type {(inputs: Pm_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapování běží na pozadí – průběh uvidíte i ve zvonečku.`)
};

const en_pm_started = /** @type {(inputs: Pm_StartedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapping runs in the background – progress is also in the bell.`)
};

/**
* | output |
* | --- |
* | "Mapping runs in the background – progress is also in the bell." |
*
* @param {Pm_StartedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_started = /** @type {((inputs?: Pm_StartedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_StartedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_started(inputs)
	return cs_pm_started(inputs)
});